import React from 'react';

const testIds = {
    MUTED_SPEAKER_ICON: 'MUTED_SPEAKER_ICON'
};

const MutedSpeakerIcon = (props: any) => (
    <svg
        data-test-id={testIds.MUTED_SPEAKER_ICON}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.1324 3.88232L6.05885 7.94118H2V16.0589H6.05885L11.1324 20.1177H13.1618V3.88232H11.1324ZM11.1324 6.48005V17.5201L6.76915 14.0295H4.02943V9.97066H6.76915L11.1324 6.48005ZM20.1736 12.0001L22 13.8164L20.5591 15.2573L18.7428 13.4308L16.9265 15.2472L15.4856 13.8063L17.3019 12.0001L15.4856 10.1837L16.9265 8.74284L18.7428 10.5693L20.5591 8.75299L22 10.1837L20.1736 12.0001Z"
            fill="#F9FAFA"
        />
    </svg>
);

export {MutedSpeakerIcon};
